import { gql } from '@apollo/client';

export const PACK_REPORTS_ZIP = gql`
  mutation packReportsZip($batchId: String!) {
    packReportsZip(batchId: $batchId)
  }
`;
